import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import PsContext from "../../context";

import { Link, useNavigate } from "react-router-dom";
import { ServiceUrl } from "../../utils/serviceUrl";
import CollegeLogo from "../collegeLogo";
import { Avatar } from "@mui/material";
import { MOB_ICONS, upperCase } from "../../utils";

const V2SinglePassword = (props) => {
  const context = useContext(PsContext);
  const navigation = useNavigate();
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [passType, setPassType] = useState("password");

  const field = (fieldName) => props?.employeeSource?.[fieldName] || "";

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    context.setLoader(true);
    axios
      .post(ServiceUrl.LOGIN_V2.CHECK_MOBILE_PASSWORD, new FormData(form))
      .then((res) => {
        if (res.data.status == "1") {
          context.setStorage("mob_attendance_date", "");
          axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
          context.saveLogin(
            res["data"].data,
            res["data"].api,
            res["data"].permissions,
            []
          );
          context.updateMobileUserId(res.data.data.uuid);
          context.setStorage("login_by", "staff");
          context.setStorage("employee_name", res.data.data.employee_name);

          context.updateAcyear(res["data"].acyear);

          context.updateLogged();
        } else {
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
        }
        context.setLoader(false);
      });
  };

  const changeMobileClick = () => {
    context.setStorage("employee_name", "");
    context.updateMobileUserId("");
    if (props.onCancel) props.onCancel();
  };

  return (
    <>
      <div data-aos="zoom-in">
        <div className="text-center">
          <div className="login-img mt-5 d-flex justify-content-center align-content-center">
            <img
              className="ms-3"
              src={MOB_ICONS.PASSWORD_256}
              style={{ width: "100%", maxWidth: "120px" }}
            />
          </div>

          <div className="login mt-4 my-2">
            <h2 className="fw-bold text-center">Welcome</h2>

            <div
              style={{ fontSize: "16px", color: "#ab0000" }}
              className="fw-bold "
            >
              {field("employee_name")}
            </div>
            <p className="text-center mb-4 mt-2">
              Enter password to access your account
            </p>
          </div>
        </div>

        <div className="py-4">
          <Form
            action=""
            method="post"
            noValidate
            validated={validated}
            onSubmit={handleFormSubmit}
          >
            <input type="hidden" name="uuid" value={field("uuid")} />
            <input
              type="hidden"
              name="device_id"
              value={context.getStorage("user_device_id")}
            />

            <Row>
              <Col md={12}>
                <InputGroup>
                  <Form.Control
                    type={passType}
                    className="fw-bold"
                    name="password"
                    placeholder="Enter Password"
                    autoComplete={"off"}
                    autoFocus={true}
                    required
                  />
                  <InputGroup.Text
                    className="bg-white border-0"
                    onClick={(e) =>
                      setPassType(passType == "password" ? "text" : "password")
                    }
                  >
                    {passType == "password" ? (
                      <i className="fa-solid fa-eye"></i>
                    ) : (
                      <i className="fa-regular fa-eye-slash"></i>
                    )}
                  </InputGroup.Text>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  Password is required
                </Form.Control.Feedback>
              </Col>
              <Col
                md={12}
                className="mt-2 d-flex justify-content-center align-content-center"
              >
                <Link to="/staff/forgot-pass">
                  <span className="text-black fs-6 me-1">
                    {" "}
                    Have you forgotten your
                  </span>
                  <span className="fw-bold fs-6 theme-text">Password?</span>
                </Link>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={12}>
                <Button
                  type="submit"
                  variant="danger"
                  size="lg"
                  className="w-100 bg-theme"
                >
                  Go Next
                </Button>
              </Col>
            </Row>
          </Form>
          <div className="mt-5">
            <Button
              type="button"
              size="lg"
              className="w-100"
              variant="outline-dark border"
              onClick={(e) => changeMobileClick()}
            >
              Change Mobile Number
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default V2SinglePassword;
